import React, { useEffect, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';
import { Button } from '../UI-CHAKRA/Button';
import { ReactComponent as AllegrilIcon } from '../../assets/images/psp/allegril.svg';

interface PspAlreadyRegisteredStepProps {
  onClose: () => void;
  onEventEmission: (eventName: string, eventData: Record<string, unknown>) => void;
}

const PspAlreadyRegisteredStep: React.FC<PspAlreadyRegisteredStepProps> = ({ onClose, onEventEmission }) => {
  const hasEmittedViewEventRef = useRef(false);

  useEffect(() => {
    if (hasEmittedViewEventRef.current) return;
    hasEmittedViewEventRef.current = true;
    onEventEmission('backoffice_campaign_psp_incluido_feedback', {
      flow: 'selecionar medicamento',
      statusCadastro: 'cadastrado',
    });
  }, [onEventEmission]);

  return (
    <Flex flexDirection={'column'} height={'100%'} overflow="hidden">
      <Box flexShrink={0} borderBottom={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} padding={'20px'}>
          <Text fontSize={'18px'} fontWeight={700} color={'#343A40'}>
            Programa de Benefício em Medicamentos
          </Text>
          <CloseIcon onClick={onClose} cursor={'pointer'} />
        </Flex>
      </Box>

      <Box flexGrow={1} overflowY={'auto'} overflowX="hidden" padding={'120px 20px 20px 20px'}>
        <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={'24px'} minH={'400px'}>
          <Box
            width={'150px'}
            height={'150px'}
            borderRadius={'50%'}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <AllegrilIcon width={'150px'} height={'150px'} />
          </Box>

          <Text fontSize={'24px'} fontWeight={700} color={'#3D0E6B'} textAlign={'center'}>
            Boas notícias!
          </Text>

          <Text fontSize={'14px'} color={'#3D0E6B'} textAlign={'center'} maxW={'400px'}>
            O paciente já foi incluído no Programa de Suporte ao Paciente (PSP).
          </Text>
        </Flex>
      </Box>

      <Box flexShrink={0} padding={'20px'} borderTop={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} gap={'12px'} justifyContent={'flex-end'}>
          <Button
            onClick={onClose}
            padding="10px 20px"
            backgroundColor={'primary.main'}
            borderRadius={'20px'}
            color={'#FFF'}
            fontSize={'14px'}
            _hover={{ backgroundColor: '#6B409C' }}
          >
            Fechar
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default PspAlreadyRegisteredStep;
